<!-- Phone-only: the card layout hides the sortable header row, so this is how sorting is reached. -->
<div class="mobile-sort" *ngIf="columns?.length">
  <mat-form-field appearance="outline" class="mobile-sort__field">
    <mat-label>Sort by</mat-label>
    <mat-select [value]="active" (selectionChange)="onColumnChange($event.value)"
                panelClass="mobile-sort__panel" aria-label="Sort cards by column">
      <mat-option *ngFor="let c of columns" [value]="c.id">{{ c.label }}</mat-option>
    </mat-select>
  </mat-form-field>

  <button type="button" class="mobile-sort__dir" (click)="toggleDirection()"
          [attr.aria-label]="'Sort direction: ' + directionLabel">
    <span class="mobile-sort__arrow" aria-hidden="true">{{ direction === 'desc' ? '↓' : '↑' }}</span>
    <span class="mobile-sort__dirtext">{{ directionLabel }}</span>
  </button>
</div>
